import baseHeader from '@/components/mixins/baseHeader'
import searchHeader from '@/components/mixins/searchHeader'
import baseTable from '@/components/mixins/baseTable'
import selectTable from '@/components/mixins/selectTable'
import baseForm from '@/components/mixins/baseForm'
import msgDialog from '@/components/mixins/msgDialog'
import formDialog from '@/components/mixins/formDialog'
import { desEncrypt } from '@/utils/index'
import { mapGetters, mapActions } from 'vuex'

export default {
  mixins: [baseHeader, baseTable, msgDialog, formDialog, searchHeader, baseForm, selectTable],
  data () {
    var pswRepeat = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.updateForm.psw) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var pswRepeat2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.addForm.psw) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var username = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        // callback()
        var params = {
          username: value
        }
        this.$request.fetchSysUsernameUnique(params).then(res => {
          if (res.code === 200) {
            if (res.data) {
              callback()
            } else {
              callback(new Error('用户名已存在'))
            }
          } else {
            callback(new Error(res.message))
          }
        })
      }
    }
    var email = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else {
        // callback()
        var params = {
          mail: value
        }
        this.$request.fetchSysMailUnique(params).then(res => {
          if (res.code === 200) {
            if (res.data) {
              callback()
            } else {
              callback(new Error('邮箱已存在'))
            }
          } else {
            callback(new Error(res.message))
          }
        })
      }
    }
    var phone = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else {
        // callback()
        var params = {
          phone: value
        }
        this.$request.fetchSysPhoneUnique(params).then(res => {
          if (res.code === 200) {
            if (res.data) {
              callback()
            } else {
              callback(new Error('手机号码已存在'))
            }
          } else {
            callback(new Error(res.message))
          }
        })
      }
    }
    var passoword = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else {
        // callback()
        var params = {
          psw: desEncrypt(value),
          username: ''
        }
        this.$request.fetchSysPwdUnique(params).then(res => {
          if (res.code === 200) {
            if (res.data) {
              callback()
            } else {
              callback(new Error(res.message))
            }
          } else {
            callback(new Error(res.message))
          }
        })
      }
    }
    var IsEqually = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else {
        if (this.setting.attrs.passIsEqually === '0') {
          if (this.addForm.psw === this.addForm.username) {
            callback(new Error('密码与用户名不允许相同'))
          }
          callback()
        } else {
          callback()
        }
      }
    }
    var IsEqually2 = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else {
        if (this.setting.attrs.passIsEqually === '0') {
          if (this.updateForm.psw === this.updateForm.username) {
            callback(new Error('密码与用户名不允许相同'))
          }
          callback()
        } else {
          callback()
        }
      }
    }
    return {
      openSecurity: null,
      updateFormLoading: false,
      updateForm: {
        'username': '',
        'psw': '',
        'psw2': '',
        'id': '',
        'enabled': ''
      },
      updateRules: {
        psw: [
          this.$rules.required(),
          { validator: passoword, trigger: 'blur' },
          { validator: IsEqually2, trigger: 'blur' }
        ],
        psw2: [
          this.$rules.required(),
          { validator: pswRepeat, trigger: 'blur' }
        ]
      },
      updateFormItems: [
        {
          prop: 'username',
          label: '用户名',
          maxlength: 20,
          type: 'text'
        },
        {
          prop: 'psw',
          label: '密码',
          type: 'password',
          maxlength: 50,
          autocomplete: 'off',
          placeholder: '请输入您的密码'
        },
        {
          prop: 'psw2',
          label: '重复密码',
          type: 'password',
          autocomplete: 'off',
          placeholder: '请再次输入您的密码'
        }
      ],
      updateButtons: [
        {
          text: '保存',
          type: 'Submit'
        }
      ],
      addFormLoading: false,
      addForm: {
        'username': '',
        'psw': '',
        'realname': '',
        'gender': '',
        'usePhone': '',
        'email': '',
        'psw2': '',
        'postAddress': '',
        'company': '',
        'job': '',
        'enabled': [],
        'content': '填写信息后您可投递稿件'
      },
      addButtons: [
        {
          text: '保存',
          type: 'Submit'
        }
      ],
      addRules: {
        username: [
          this.$rules.required(),
          { validator: username, trigger: 'blur' },
          { validator: IsEqually, trigger: 'blur' }
        ],
        psw: [
          this.$rules.required(),
          { validator: passoword, trigger: 'blur' },
          { validator: IsEqually, trigger: 'blur' }
        ],
        psw2: [
          this.$rules.required(),
          { validator: pswRepeat2, trigger: 'blur' }
        ],
        email: [
          this.$rules.email(),
          this.$rules.required(),
          { validator: email, trigger: 'blur' }
        ],
        usePhone: [
          this.$rules.mobile(),
          this.$rules.required(),
          { validator: phone, trigger: 'blur' }
        ],
        realname: [
          this.$rules.required()
        ],
        gender: [
          this.$rules.required()
        ],
        postAddress: [
          this.$rules.required()
        ],
        company: [
          this.$rules.required()
        ],
        job: [
          this.$rules.required()
        ],
        enabled: [
          this.$rules.required()
        ]
      },
      addFormItems: [
        {
          prop: 'username',
          label: '用户名',
          placeholder: '请输入您的用户名',
          maxlength: 20
        },
        {
          prop: 'psw',
          label: '密码',
          type: 'password',
          maxlength: 50,
          placeholder: '请输入您的密码'
        },
        {
          prop: 'psw2',
          label: '重复密码',
          type: 'password',
          placeholder: '请再次输入您的密码'
        },
        {
          prop: 'realname',
          label: '真实姓名',
          maxlength: 50,
          placeholder: '请输入您的真实姓名'
        },
        {
          type: 'radio',
          prop: 'gender',
          label: '性别',
          options: [
            {
              label: '男',
              value: 1
            },
            {
              label: '女',
              value: 2
            }
          ]
        },
        {
          prop: 'usePhone',
          label: '手机',
          maxlength: 20,
          placeholder: '请输入您的手机号码'
        },
        {
          prop: 'email',
          label: '电子邮箱',
          maxlength: 30,
          placeholder: '请输入您的电子邮箱'
        },
        {
          prop: 'postAddress',
          label: '邮寄地址'
        },
        {
          prop: 'company',
          label: '所在单位'
        },
        {
          prop: 'job',
          label: '学历/职称'
        },
        {
          prop: 'enabled',
          label: '',
          type: 'checkbox',
          options: [
            {
              label: '本人同意网站',
              rawHtml: '<a href="http://pkulawrev.law.pku.edu.cn/jeecms/index.html#/agree" target="_blank" style="color: #1fc6df">注册章程</a>',
              value: true
            }
          ]
        },
        {
          prop: 'content',
          label: '',
          type: 'text'
        }
      ],
      type: 1,
      resetFormLoading: false,
      resetForm: {
        'username': '',
        'email': ''
        // 'tips': '输入用户名和邮箱, 新密码会通过邮件的形式发送到该邮箱'
      },
      resetButtons: [
        {
          text: '确定',
          type: 'Submit'
        }
      ],
      resetRules: {
        username: [
          this.$rules.required()
        ],
        email: [
          this.$rules.email(),
          this.$rules.required()
        ]
      },
      resetFormItems: [
        {
          prop: 'username',
          label: '用户名',
          placeholder: '请输入您的用户名',
          maxlength: 20
        },
        {
          prop: 'email',
          label: '电子邮箱',
          maxlength: 30,
          placeholder: '请输入您的电子邮箱'
        }
        // {
        //   prop: 'tips',
        //   type: 'text',
        //   label: '提示',
        // }
      ]
    }
  },
  methods: {
    ...mapActions('system', ['FetchUserSecurityOptions', 'FetchOrganizeOptions', 'FetchRoleOptions']),
    handleConfirmAdd (data, btn, type) { // 新增用户
      console.log(data)
      this.addFormLoading = true
      var params = Object.assign({}, data)
      // params.orgid = data.orgids[data.orgids.length - 1]
      params.psw = desEncrypt(data.psw)
      params.enabled = data.enabled[0]
      // delete params.orgids
      delete params.psw2
      delete params.content
      this.$request.fetchUserCenterDataAdd(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        }
        this.addFormLoading = false
      }).catch(() => {
        this.addFormLoading = false
      })
    },
    handleConfirmReset (data, btn, type) { // 新增用户
      console.log(data)
      this.resetFormLoading = true
      var params = Object.assign({}, data)

      this.$request.fetchResetPw(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功, 请去邮箱查看新密码',
            type: 'success'
          })
        } else {
          // this.$message({
          //   message: '用户名与邮箱不匹配',
          //   type: 'error'
          // })
        }
        this.resetFormLoading = false
      }).catch(() => {
        this.resetFormLoading = false
      })

      // this.$confirm('此操作将发送新密码到注册邮箱, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.$request.fetchResetPw(params).then(res => {
      //     if (res.code === 200) {
      //       this.$message({
      //         message: '操作成功',
      //         type: 'success'
      //       })
      //     } else {
      //       this.$message({
      //         message: '用户名与邮箱不匹配',
      //         type: 'error'
      //       })
      //     }
      //     this.resetFormLoading = false
      //   }).catch(() => {
      //     this.resetFormLoading = false
      //   })
      // }).catch(() => {})
    }
  },
  computed: {
    // 获取系统设置项
    ...mapGetters(['setting', 'system', 'user', 'organizeOptions', 'roleOptions']),
    openContentSecurity () {
      const { openContentSecurity } = this.setting.attrs || {}
      return openContentSecurity
    },
    userSecurityOptions () {
      return this.system.userSecurityOptions
    }
  }
}
